import { render, staticRenderFns } from "./GlobalSearchModal.vue?vue&type=template&id=6ec4d4fa&scoped=true"
import script from "./GlobalSearchModal.vue?vue&type=script&lang=ts"
export * from "./GlobalSearchModal.vue?vue&type=script&lang=ts"
import style0 from "./GlobalSearchModal.vue?vue&type=style&index=0&id=6ec4d4fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec4d4fa",
  null
  
)

export default component.exports